module.exports = __webpack_public_path__ + "img/NL685.59cbbe36.png";